module.exports = __webpack_public_path__ + "ui-bg_diagonals-thick_18_b81900_40x40.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-bg_diagonals-thick_18_b81900_40x40.png
// module id = 808
// module chunks = 1